import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.1_@types+node@18.19.80_db0@0.3.1_encoding@0.1.13_eslint@9.14._wmrwqeaypk66vaphq24bqzyape/node_modules/nuxt/dist/pages/runtime/validate.js";
import page_45transition_45global from "/vercel/path0/middleware/pageTransition.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.1_@types+node@18.19.80_db0@0.3.1_encoding@0.1.13_eslint@9.14._wmrwqeaypk66vaphq24bqzyape/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  page_45transition_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}